export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12793.b19fde2e.jpg";